import React from 'react';
import type { FC } from 'react';
import { TextInput } from '@wix/cli-ui-kit';
import { useAppToolsNameValidation } from '../../../dev-center/components/validations/index.js';
import { useWixCliAstroBi } from '../../../bi/index.js';
import { useWizardStep } from '../Wizard.js';
import { useProjectModel } from '../../../model.js';

export const ChooseNameStep: FC<{
  name?: string;
  onSubmit: (value: string) => void;
}> = ({ onSubmit, name }) => {
  const { model } = useProjectModel();
  const bi = useWixCliAstroBi();
  const { isActive, goToNextStep } = useWizardStep();

  const validateName = useAppToolsNameValidation(model.projectFolder);

  return (
    <TextInput
      isActive={isActive}
      label={'How would you like to name your app tools extension'}
      placeholder={name ?? 'app-tools'}
      onSubmit={(value) => {
        bi.cliFlowStepAnswered({
          question: 'How would you like to name your app tools extension',
          questionKey: 'generate_command.app_tools.choose_name',
          answer: value,
        });
        onSubmit(value);
        goToNextStep();
      }}
      validate={validateName}
    />
  );
};
